import { render, staticRenderFns } from "./sso-lti.vue?vue&type=template&id=77231c9c&"
import script from "./sso-lti.ts?vue&type=script&lang=ts&"
export * from "./sso-lti.ts?vue&type=script&lang=ts&"
import style0 from "./sso-lti.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports